import { render } from "./Brand24sata.vue?vue&type=template&id=1e6696b7"
import script from "./Brand24sata.vue?vue&type=script&lang=ts"
export * from "./Brand24sata.vue?vue&type=script&lang=ts"

import "./Brand24sata.vue?vue&type=style&index=0&id=1e6696b7&lang=scss"
script.render = render

export default script